import {
  HOTEL_URL_PARAM_KEYS,
  QueryParamType,
  useParseQueryParams,
} from "@b2bportal/core-utilities";
import type { LodgingSelection } from "@b2bportal/lodging-api";

export const useGetShopQueryParams = () => {
  const params = {
    [HOTEL_URL_PARAM_KEYS.FROM_DATE]: {
      type: QueryParamType.requiredString,
    },
    [HOTEL_URL_PARAM_KEYS.UNTIL_DATE]: {
      type: QueryParamType.requiredString,
    },
    [HOTEL_URL_PARAM_KEYS.ADULTS_COUNT]: {
      type: QueryParamType.requiredNumber,
    },
    [HOTEL_URL_PARAM_KEYS.CHILDREN_AGES]: {
      type: QueryParamType.optionalNumberArray,
    },
    [HOTEL_URL_PARAM_KEYS.ROOMS_COUNT]: {
      type: QueryParamType.optionalNumber,
    },
    [HOTEL_URL_PARAM_KEYS.LODGING_SELECTION]: {
      type: QueryParamType.optionalString,
      parse: (val) => {
        const encodedLodgingSelection =
          val != null ? decodeURIComponent(val) : null;

        // TODO: add type validation
        return encodedLodgingSelection != null
          ? (JSON.parse(encodedLodgingSelection) as LodgingSelection)
          : null;
      },
    },
  };

  return useParseQueryParams(params);
};
